import ICMAxios from "../ICMAxios";

const getItemsByClient = async (params: any) => {
  const response = await ICMAxios.post(`v1/Item`, params);
  return response.data;
};
const addItems = async (formData: any) => {
  const response = await ICMAxios.post(`v1/Item/add`, formData);
  return response.data;
};

const updateItem = async (formData: any) => {
  const response = await ICMAxios.put(`v1/Item`, formData);
  return response.data;
};
const updateItemStatus = async (formData: any) => {
  const response = await ICMAxios.put(`v1/Item/itemstatus`, formData);
  return response.data;
};
const updateItemFlags = async (formData: any) => {
  const response = await ICMAxios.put(`v1/Item/itemflag`, formData);
  return response.data;
};
const itemService = {
  getItemsByClient,
  addItems,
  updateItem,
  updateItemStatus,
  updateItemFlags,
};

export default itemService;
